module.exports = __webpack_public_path__ + "img/BAU_Partners_5.c069c567.jpg";